'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = _React2.default.createClass({
  displayName: 'SkeletonTimePicker',
  renderTimePickerButtons: function renderTimePickerButtons() {
    return [].concat(_toConsumableArray(Array(4))).map(function (value, index) {
      return _React2.default.createElement(
        'div',
        { key: index, className: 'p-y-1 p-right-1' },
        _React2.default.createElement(
          _UISelectableBox2.default,
          {
            block: true,
            padded: false,
            selected: false,
            className: 'time-picker-btn'
          },
          _React2.default.createElement('div', { className: 'skeleton' })
        )
      );
    });
  },
  renderInputs: function renderInputs() {
    return _React2.default.createElement(
      'div',
      { className: 'time-list-container' },
      _React2.default.createElement(
        'div',
        { className: 'time-list' },
        this.renderTimePickerButtons()
      )
    );
  },
  render: function render() {
    return _React2.default.createElement(
      'div',
      { className: 'time-picker time-picker-skeleton width-100' },
      _React2.default.createElement(
        'h5',
        { className: 'skeleton-text' },
        _React2.default.createElement(_I18nReact2.default, { message: 'prebook.timePicker.header' })
      ),
      this.renderInputs()
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/time/SkeletonTimePicker.js
// module id = 441
// module chunks = 0